/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerActivityRecordType;

(function (BrokerActivityRecordType) {
  BrokerActivityRecordType["BUSINESS_VIEW"] = "business_view";
  BrokerActivityRecordType["DEMO"] = "demo";
  BrokerActivityRecordType["ONBOARDING_PROCESS_WORKFLOW"] = "onboarding_process_workflow";
  BrokerActivityRecordType["ONLINE_TRAINING"] = "online_training";
  BrokerActivityRecordType["IN_PERSON_TRAINING"] = "in_person_training";
})(BrokerActivityRecordType || (BrokerActivityRecordType = {}));